import { AggregateIdWithIdoAndInstanceId } from 'src/models/aggregate';
import { AbstractCommand } from 'src/models/command';
import { PhoneCall } from 'src/models/phoneCall';

import { isNumber } from 'src/util/common';

class ProcessPhoneCallCommand extends AbstractCommand {
	public apiVersion = 2;
	readonly name = 'IFS_PhoneCall_Commands_ProcessPhoneCall';

	public constructor(phoneCall: PhoneCall) {
		super();

		const callReason = phoneCall.callReason;

		this.parameters = {
			aggregateId: phoneCall.aggregateId,
			aggregateVersion: phoneCall.aggregateVersion,
			callBackDesired: phoneCall.callbackDesired,
			callSummary: phoneCall.callSummary,
			callerNumber: phoneCall.callerNumber,
			direction: phoneCall.direction === 'out' ? 1 : 0,
			duration: phoneCall.duration,
			newCallerName: phoneCall.newCallerName,
			number2nameGuid: phoneCall.callerName !== null && isNumber(phoneCall.callerName) ? phoneCall.callerName : 0,
			phoneCallList: phoneCall.callList,
			phoneCallListId: phoneCall.callListId,
			reason: callReason,
			receivedBy: phoneCall.callReceivedBy,
			receivedFor: phoneCall.callReceivedFor,
			timestamp: phoneCall.callTimestamp,
			updatedCallerName: phoneCall.updatedCallerName,
		};
	}
}

class CreateANewPhonecallCommand extends AbstractCommand {
	readonly name = 'IFS_Desktop_Command_Command_Legacy_Modules_PhoneCall_CreateANewPhoneCall';

	public constructor(
		timestamp = 0,
		phoneCallListId = 0,
		newCallerName = '',
		callerNumber = '',
		reason = '',
		receivedBy = 0,
		receivedFor = 0,
		callBackDesired = false,
		direction = 1,
		duration = 0,
		idoLinkings: Array<AggregateIdWithIdoAndInstanceId> = []
	) {
		super();

		this.parameters = {
			callBackDesired: callBackDesired,
			callerNumber: callerNumber,
			direction: direction,
			duration: duration,
			idoLinkings: idoLinkings,
			newCallerName: newCallerName,
			phoneCallListId: phoneCallListId,
			reason: reason,
			receivedBy: receivedBy,
			receivedFor: receivedFor,
			timestamp: timestamp,
		};
	}
}

class MergeThePhoneCallPhoneBookEntriesCommand extends AbstractCommand {
	readonly name = 'IFS_Desktop_Command_Command_Legacy_Modules_PhoneCall_MergeThePhoneCallPhoneBookEntries';

	public constructor(
		primaryPhoneBookEntryId: number,
		replacedPhoneBookEntryIds: Array<number>,
		ignoredPhoneBookEntryIds: Array<number>
	) {
		super();

		this.parameters = {
			ignoredPhoneBookEntryIds: ignoredPhoneBookEntryIds,
			primaryPhoneBookEntryId: primaryPhoneBookEntryId,
			replacedPhoneBookEntryIds: replacedPhoneBookEntryIds,
		};
	}
}

class SetTheContactPictureForThePhoneCallNumberCommand extends AbstractCommand {
	readonly name = 'IFS_Desktop_Command_Command_Legacy_Modules_PhoneCall_SetTheContactPictureForThePhoneCallNumber';

	public constructor(aggregateId: string, phoneCallNumber: string, contactPictureVersion: number, payload: string) {
		super();

		this.parameters = {
			aggregateId,
			contactPictureVersion,
			payload,
			phoneCallNumber,
		};
	}
}

class DeleteTheContactPictureForThePhoneCallNumberCommand extends AbstractCommand {
	readonly name = 'IFS_Desktop_Command_Command_Legacy_Modules_PhoneCall_DeleteTheContactPictureForThePhoneCallNumber';

	public constructor(aggregateId: string, phoneCallNumber: string) {
		super();

		this.parameters = {
			aggregateId,
			phoneCallNumber,
		};
	}
}

class UpdateThePhoneCallPhoneBookEntryName extends AbstractCommand {
	readonly name = 'IFS_Desktop_Command_Command_Legacy_Modules_PhoneCall_UpdateThePhoneCallPhoneBookEntryName';

	public constructor(phonebookNumber2NameId: number, updatedName: string) {
		super();

		this.parameters = {
			phonebookNumber2NameId: phonebookNumber2NameId,
			updatedName: updatedName,
		};
	}
}

class UpdateThePhoneCallPhoneBookNameNumber extends AbstractCommand {
	readonly name = 'IFS_Desktop_Command_Command_Legacy_Modules_PhoneCall_UpdateThePhoneCallPhoneBookEntryNumber';

	public constructor(phonebookNumber2NameId: number, updatedNumber: string) {
		super();

		this.parameters = {
			phonebookNumber2NameId: phonebookNumber2NameId,
			updatedNumber: updatedNumber,
		};
	}
}

export {
	CreateANewPhonecallCommand,
	DeleteTheContactPictureForThePhoneCallNumberCommand,
	MergeThePhoneCallPhoneBookEntriesCommand,
	ProcessPhoneCallCommand,
	SetTheContactPictureForThePhoneCallNumberCommand,
	UpdateThePhoneCallPhoneBookEntryName,
	UpdateThePhoneCallPhoneBookNameNumber,
};
